module.exports = __webpack_public_path__ + "img/奖杯.a6e59807.png";